// @flow
import React, { Component } from 'react';
import { Query } from '@apollo/client/react/components';
import { WrappedSpinner } from 'spinner';
import { NotificationMessage, Sidebar } from 'bench-internal-theme';
import { ClientIdContext } from 'bk-web-app';

import { GET_JOURNAL_ENTRY } from './queries';
import JournalEntryContent from './JournalEntryContent';
// $FlowFixMe - TS File
import JournalEntryFormContainer from './JournalEntryFormContainer';
import { ClientRulesSidebar } from '../bk-web-app/client-rules-sidebar';

/**
 * Calculates the total amount of the journal entry. This is the sum
 * of the absolute value of data entry credits.
 * @param dataEntries - List of data entry objects
 * @returns {number} - Journal Entry amount in cents
 */
const getJournalEntryAmount = dataEntries =>
  dataEntries
    .filter(entry => entry.amountInCents < 0)
    .map(entry => Math.abs(entry.amountInCents))
    .reduce((a, b) => a + b, 0);

type JournalEntrySidebarContainerProps = {
  dismiss: () => void,
  journalEntryId: string,
};

type JournalEntrySidebarContainerState = {
  isEditingJournalEntry: boolean,
  isEditingClientRule: boolean,
};

class JournalEntryContentContainer extends Component<
  JournalEntrySidebarContainerProps,
  JournalEntrySidebarContainerState,
> {
  state = {
    isEditingJournalEntry: false,
    isEditingClientRule: false,
  };

  render() {
    const { dismiss, journalEntryId } = this.props;
    const { isEditingJournalEntry, isEditingClientRule } = this.state;

    return (
      <ClientIdContext.Consumer>
        {clientId => (
          <Query query={GET_JOURNAL_ENTRY} variables={{ id: journalEntryId }}>
            {({ loading, error, data }: any) => {
              if (loading) {
                return <WrappedSpinner />;
              }

              if (error) {
                return (
                  <NotificationMessage styleType="error">
                    There was an error fetching this journal entry
                  </NotificationMessage>
                );
              }

              const { dataEntries, clientCatResponse } = data.journalEntry;

              const amountInCents = getJournalEntryAmount(dataEntries);

              const { internalNotes, clientComments, historyEntries } = data.journalEntry;

              if (isEditingJournalEntry) {
                return (
                  <Sidebar headerContent="Edit Journal Entry" dismiss={dismiss}>
                    <JournalEntryFormContainer
                      journalEntryId={journalEntryId}
                      key={data.journalEntry.id}
                      onComplete={() => {
                        this.setState({ isEditingJournalEntry: false });
                      }}
                    />
                  </Sidebar>
                );
              } else if (isEditingClientRule) {
                return (
                  <ClientRulesSidebar
                    dismiss={() => {
                      this.setState({ isEditingClientRule: false });
                    }}
                    clientRuleId={data.journalEntry.categorizerRuleId}
                  />
                );
              }

              return (
                <JournalEntryContent
                  amountInCents={amountInCents}
                  clientCatResponse={clientCatResponse}
                  clientComments={clientComments}
                  clientId={clientId}
                  dismiss={dismiss}
                  historyEntries={historyEntries}
                  internalNotes={internalNotes}
                  journalEntry={data.journalEntry}
                  showClientRuleEditForm={() => {
                    this.setState({ isEditingJournalEntry: false, isEditingClientRule: true });
                  }}
                  key={journalEntryId}
                  showJournalEntryEditForm={() => {
                    this.setState({ isEditingJournalEntry: true, isEditingClientRule: false });
                  }}
                />
              );
            }}
          </Query>
        )}
      </ClientIdContext.Consumer>
    );
  }
}

export default JournalEntryContentContainer;
